"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCompulsoryDinners = void 0;
const getCompulsoryDinners = (line) => {
    const dinners = [];
    // Get all unique dinners from both room rates and compulsory dinners
    const uniqueDinners = new Map();
    // Add dinners from room rates
    line.rooms.rooms.forEach((room) => {
        room.rate.forEach((rate) => {
            if (rate?.dinners) {
                rate.dinners.forEach((dinner) => {
                    if (dinner.id) {
                        uniqueDinners.set(dinner.id, dinner);
                    }
                });
            }
        });
    });
    // Add dinner descriptions
    uniqueDinners.forEach((dinner) => {
        // Customize this description based on your HotelContractCompulsoryDinners interface
        dinners.push(dinner);
    });
    return dinners;
};
exports.getCompulsoryDinners = getCompulsoryDinners;
